import React from 'react';

function Plus() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 11H22" stroke="black" strokeWidth="2" />
      <path d="M11 0L11 22" stroke="black" strokeWidth="2" />
    </svg>
  );
}

function Minus() {
  return (
    <svg
      width="22"
      height="2"
      viewBox="0 0 22 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 1H22" stroke="black" strokeWidth="2" />
    </svg>
  );
}

function Icon1() {
  return (
    <svg
      width="94"
      height="89"
      viewBox="0 0 94 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_67_1357)">
        <path
          d="M21.8174 0C33.4224 0 42.9384 9.47792 42.9384 20.9208C42.9384 32.4792 33.4224 41.9571 21.8174 41.8416C10.2125 41.8416 0.928549 32.4792 0.8125 20.9208C0.8125 9.47792 10.2125 0 21.8174 0Z"
          fill="black"
        />
        <path d="M90.983 0H48.625V42.1883H90.983V0Z" fill="black" />
        <path d="M42.358 46.8115H0V88.9998H42.358V46.8115Z" fill="black" />
        <path
          d="M44.4473 88.8844H94.0003L67.7732 46.9272L44.4473 88.8844Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_67_1357">
          <rect width="94" height="89" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function Icon2() {
  return (
    <svg
      width="127"
      height="124"
      viewBox="0 0 127 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_67_1152)">
        <path
          d="M126.846 63.4217L96.6523 33.2285L66.4592 63.4217L96.6523 93.6149L126.846 63.4217Z"
          fill="black"
        />
        <path
          d="M48.5 81L89.8 99.4L69.4 104.1L61.3 123.7L48.5 81Z"
          fill="black"
        />
        <path
          d="M93.6717 30.1697L63.4785 -0.0234375L33.2853 30.1697L63.4785 60.3629L93.6717 30.1697Z"
          fill="black"
        />
        <path
          d="M60.3494 63.4139L30.1562 33.2207L-0.0369221 63.4139L30.1562 93.607L60.3494 63.4139Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_67_1152">
          <rect width="126.9" height="123.7" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function Icon3() {
  return (
    <svg
      width="109"
      height="109"
      viewBox="0 0 109 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_67_1292)">
        <path
          d="M90.9554 90.899C96.5379 85.3165 102.177 79.6776 107.759 74.0951C107.985 73.8695 108.267 73.5876 108.492 73.362C109.169 72.5162 109.282 71.4448 108.492 70.6554C106.406 68.6254 104.432 66.4262 102.12 64.7345C90.2787 56.107 74.0951 58.4753 65.1292 70.0351C58.5881 78.437 57.7986 90.166 63.0992 99.5265C64.9036 102.741 67.4975 105.278 70.035 107.816C71.5575 109.338 72.4598 109.338 73.9823 107.816C79.6212 102.177 85.2601 96.5379 90.9554 90.899Z"
          fill="white"
        />
        <path
          d="M90.9556 90.899C85.3167 96.5379 79.6778 102.177 74.0389 107.816C72.5164 109.338 71.6142 109.338 70.0917 107.816C67.4978 105.278 64.9603 102.741 63.1558 99.5265C57.8553 90.166 58.6447 78.4934 65.1858 70.0351C74.1517 58.4753 90.3353 56.107 102.177 64.7345C104.489 66.4262 106.463 68.6254 108.549 70.6554C109.338 71.3884 109.226 72.5162 108.549 73.362C108.323 73.644 108.098 73.8695 107.816 74.0951C102.121 79.6776 96.5381 85.2601 90.9556 90.899Z"
          fill="black"
        />
        <path
          d="M64.9611 43.8707C70.9947 49.8479 70.9947 59.716 64.9611 65.6932C58.9275 71.6704 49.1158 71.6704 43.1386 65.6932C37.1613 59.6596 37.1613 50.0171 43.1386 43.927C49.1158 37.8934 58.9275 37.837 64.9611 43.8707Z"
          fill="black"
        />
        <path
          d="M90.8418 18.0444C85.2593 12.4619 79.6768 6.87936 74.0379 1.29684C73.8123 1.07129 73.5304 0.789342 73.3048 0.563786C72.459 -0.112882 71.3876 -0.22566 70.5981 0.563786C68.5681 2.65018 66.369 4.6238 64.6773 6.93575C56.0498 18.7774 58.4181 34.9611 69.9779 43.927C78.3798 50.4681 90.1087 51.2575 99.4693 45.957C102.683 44.1525 105.221 41.5586 107.759 39.0211C109.281 37.4986 109.281 36.5964 107.759 35.0739C102.176 29.3786 96.4807 23.7397 90.8418 18.0444Z"
          fill="white"
        />
        <path
          d="M90.8418 18.0444C96.4807 23.6833 102.12 29.3222 107.759 34.9611C109.281 36.4836 109.281 37.3858 107.759 38.9083C105.221 41.5022 102.683 44.0397 99.4693 45.8442C90.1087 51.1447 78.4362 50.3553 69.9779 43.8142C58.4181 34.8483 56.0498 18.6647 64.6773 6.82295C66.369 4.511 68.5681 2.53739 70.5981 0.450993C71.3312 -0.338453 72.459 -0.225675 73.3048 0.450993C73.5868 0.676549 73.8123 0.902105 74.0379 1.18405C79.6768 6.87934 85.2593 12.4619 90.8418 18.0444Z"
          fill="black"
        />
        <path
          d="M18.0437 18.1572C23.6826 12.5183 29.3215 6.87941 34.9604 1.24051C36.483 -0.281994 37.3852 -0.281994 38.9077 1.24051C41.5016 3.77802 44.0391 6.31552 45.8435 9.5297C51.1441 18.8903 50.3547 30.5628 43.8135 39.0212C34.8477 50.5809 18.664 52.9493 6.82232 44.3217C4.51037 42.6301 2.53675 40.4309 0.450354 38.4009C-0.339094 37.6678 -0.226316 36.54 0.450354 35.6942C0.675909 35.4123 0.901469 35.1867 1.18341 34.9612C6.82232 29.3222 12.4612 23.7397 18.0437 18.1572Z"
          fill="black"
        />
        <path
          d="M18.101 90.9558C12.4621 85.3169 6.82318 79.678 1.18428 74.0391C-0.338223 72.5166 -0.338223 71.6143 1.18428 70.0918C3.72179 67.4979 6.25929 64.9604 9.47346 63.156C18.834 57.8554 30.5066 58.6449 38.9649 65.186C50.5247 74.1518 52.893 90.3355 44.2655 102.177C42.5738 104.489 40.3746 106.463 38.3446 108.549C37.6116 109.339 36.4838 109.226 35.638 108.549C35.356 108.324 35.1305 108.098 34.9049 107.816C29.3224 102.177 23.7399 96.5383 18.101 90.9558Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_67_1292">
          <rect
            width="109"
            height="109"
            fill="white"
            transform="translate(109) rotate(90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default {
  Plus,
  Minus,
  Icon1,
  Icon2,
  Icon3,
};
